// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JqU9","title":"styles_title__eQhd7"};